
/* Protopia Ecosystem component */
export interface ICardOuterProps {
   i: number
}
const CardOuter = (props: ICardOuterProps): JSX.Element => {
    return <div className='pe-card-outer'>
       
    </div>
}
export default CardOuter